export const GET_WEAVE_REQUEST = 'GET_WEAVE_REQUEST';
export const GET_WEAVE_DATA = 'GET_WEAVE_DATA';
export const GET_WEAVE_ERROR = 'GET_WEAVE_ERROR';

export const CREATE_WEAVE_REQUEST = 'CREATE_WEAVE_REQUEST';
export const CREATE_WEAVE_DATA = 'CREATE_WEAVE_DATA';
export const CREATE_WEAVE_ERROR = 'CREATE_WEAVE_ERROR';

export const UPDATE_WEAVE_REQUEST = 'UPDATE_WEAVE_REQUEST';
export const UPDATE_WEAVE_DATA = 'UPDATE_WEAVE_DATA';
export const UPDATE_WEAVE_ERROR = 'UPDATE_WEAVE_ERROR';

export const DELETE_WEAVE_REQUEST = 'DELETE_WEAVE_REQUEST';
export const DELETE_WEAVE_DATA = 'DELETE_WEAVE_DATA';
export const DELETE_WEAVE_ERROR = 'DELETE_WEAVE_ERROR';
